import * as React from 'react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'MyTypes';

import { AlertModal, ConfirmationModal } from '@portal/common/components';

import _ from '../../locale';
import { LimitModal } from '../../models/data-tool';
import {
    cancelSelectionCountModal,
    confirmSelectionCountModal,
} from '../../store/data-explorer/actions';

const LimitWarnings = () => {
    const dispatch = useDispatch();

    const visibleModal = useSelector(
        (state: RootState) => state.dataExplorer.activeSelectionCountModal
    );

    const handleConfirmSelection = useCallback(() => {
        dispatch(confirmSelectionCountModal());
    }, [dispatch]);

    const handleCloseModal = useCallback(() => {
        dispatch(cancelSelectionCountModal());
    }, [dispatch]);

    return (
        <>
            <ConfirmationModal
                message={_.get('data_explorer_filters_amount_warning')}
                submitLabel={_('ignore_and_continue_button')}
                isVisible={visibleModal === LimitModal.slowPerformanceWarning}
                onClose={handleCloseModal}
                onSubmit={handleConfirmSelection}
            />
            <ConfirmationModal
                message={_('data_explorer_filters_chart_limit_exceeded')}
                submitLabel={_('disable_charts_and_continue_button')}
                isVisible={visibleModal === LimitModal.chartsLimitExceeded}
                onClose={handleCloseModal}
                onSubmit={handleConfirmSelection}
            />
            <ConfirmationModal
                message={_('data_explorer_filters_limit_exceeded')}
                submitLabel={_('ok_button')}
                isVisible={visibleModal === LimitModal.dataToolLimitExceeded}
                onClose={handleCloseModal}
                onSubmit={handleConfirmSelection}
            />
            <AlertModal
                isVisible={visibleModal === LimitModal.chartsLimitReceded}
                message={_('data_explorer_charts_data_limit_receded')}
                submitLabel={_('okay_button')}
                onClose={handleCloseModal}
                onSubmit={handleCloseModal}
            />
        </>
    );
};

export default LimitWarnings;
